import React from "react";
import type { Skin } from "./types";
import { studioSkin } from "./skins";

const SkinCtx = React.createContext<Skin>(studioSkin);

export const SkinProvider: React.FC<{ skin: Skin; children: React.ReactNode }> = ({ skin, children }) => (
  <SkinCtx.Provider value={skin}>{children}</SkinCtx.Provider>
);

export function useSkin(): Skin {
  return React.useContext(SkinCtx);
}
